export default __webpack_public_path__ + "static/media/open-sans-latin-400.f57a62e9.woff2";